import React, { useMemo } from "react";
import { motion } from "framer-motion";
import CountUp from "react-countup";
import "../css/Dashboard.css";

// Local images
import blue from "../assets/Dashboard/blue.png";
import green from "../assets/Dashboard/Green.png";
import red from "../assets/Dashboard/red.png";
import orange from "../assets/Dashboard/orange.png";
import Voilet from "../assets/Dashboard/voilet.png";
import skyblue from "../assets/Dashboard/skyblue.png";

// Map API color → local image
const colorImageMap = {
  blue: blue,
  green: green,
  pink: red,
  purple: Voilet,
  orange: orange,
  cyan: skyblue,
};

export default function DashboardCards({ data = [] }) {
  // Transform API data → UI friendly format
  const cardData = useMemo(() => {
    if (!data || data.length === 0) return [];
    return data.map((item) => ({
      label: item.title,
      value: item.value || 0,
      image: colorImageMap[item.color] || blue,
    }));
  }, [data]);

  if (!cardData.length) {
    return (
      <p className="dashboard-card-section text-gray-500">
        No dashboard data available
      </p>
    );
  }

  return (
    <div className="dashboard-card-section">
      <div className="dashboard-card-grid">
        {cardData.map((item, i) => (
          <motion.div
            key={i}
            className="dashboard-card-box"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: i * 0.15 }}
            whileHover={{ scale: 1.05 }}
          >
            <div className="dashboard-card-content">
              <p className="dashboard-card-label">{item.label}</p>
              <p className="dashboard-card-amount">
                ₹
                <CountUp
                  end={item.value}
                  duration={1.8}
                  separator=","
                  decimals={0}
                />
              </p>
            </div>
            <motion.div
              className="dashboard-card-wave"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1, delay: i * 0.2 }}
            >
              <img
                src={item.image}
                alt="wave"
                className="dashboard-card-wave-img"
              />
            </motion.div>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
